function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SuggestionsComponent from '../../components/Search/Suggestions';
import { search } from '../../store/actions/search';
import { geocoderSelect } from '../../store/actions/geocoder';
import { getHash, setHash } from '../../utils/urlUtils';
import { dataItemLoad } from '../../store/actions/datasetSlice';

/**
 * This component provides suggestion masks for the current search criteria that can ve applied to the dataset.
 * It should be used in pair with the SearchBox component
 */
function Suggestions(props) {
  var dispatch = useDispatch();
  var _useState = useState([]),
    searchHash = _useState[0],
    setSearchHash = _useState[1];
  var _useSelector = useSelector(function (state) {
      var _state$app, _state$app$project;
      return state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : (_state$app$project = _state$app.project) === null || _state$app$project === void 0 ? void 0 : _state$app$project.configs;
    }),
    searchType = _useSelector.searchType;
  var _useSelector2 = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.search;
    }),
    suggestions = _useSelector2.suggestions;
  var _useSelector3 = useSelector(function (state) {
      return state === null || state === void 0 ? void 0 : state.geocoder;
    }),
    list = _useSelector3.list;
  useEffect(function () {
    var hash = getHash('masks');
    if (hash) {
      setSearchHash(hash);
    }
  }, []);
  var handleSearch = function handleSearch(value) {
    var hash = [].concat(searchHash);
    hash.push(value);
    setSearchHash(hash);
    if (searchType === 'poi') {
      setHash('selectedItem', value);
      dispatch(dataItemLoad({
        guid: value
      }));
    } else {
      setHash('masks', hash);
      setHash('page', '');
      dispatch(search(value));
    }
  };
  return /*#__PURE__*/React.createElement(SuggestionsComponent, _extends({
    geocoderResults: list,
    suggestions: suggestions,
    onSelect: function onSelect(value, isGeocoder) {
      if (isGeocoder === void 0) {
        isGeocoder = false;
      }
      return isGeocoder ? dispatch(geocoderSelect(value)) : handleSearch(value);
    }
  }, props));
}
Suggestions.defaultProps = {
  limit: 5
};
Suggestions.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The number of items to be seen in the list */
  limit: PropTypes.number,
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {string} props.suggestions The list of masks matching current search text provided to the SearchBox Component
   * @param {Array} props.geocoderResults Thi list of POIs from Mapbox Geocoder API matching current search text provided to the SearchBox Component
   * @param {Object} methods
   * @param {function} methods.onSelect A method to call when a suggested item is selected and should be applied to the list of items
   *  */
  render: PropTypes.func
} : {};
export default Suggestions;